import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import { withTranslation } from 'react-i18next';

/**
 * Displays a stack of user avatars.
 *
 * Props:
 *   users       - array of { email, photo_link } objects
 *   maxVisible  - maximum number of avatars to show before "+N" (default 4)
 *   t           - translation function (injected by withTranslation HOC)
 */
function AvatarGroupStacked(props) {
  const { users = [], maxVisible = 4, t } = props;

  if (!users || users.length === 0) {
    return (
      <Typography variant="caption" color="text.secondary">
        {t('Public')}
      </Typography>
    );
  }

  const visible = users.slice(0, maxVisible);
  const overflow = users.length - maxVisible;

  const getInitials = email => {
    if (!email) return '?';
    const parts = email.split('@')[0].split('.');
    return parts
      .slice(0, 2)
      .map(p => p.charAt(0).toUpperCase())
      .join('');
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: -0.5 }}>
      {visible.map((user, index) => (
        <Tooltip key={user.email || index} title={user.email || ''}>
          <Avatar
            src={user.photo_link || undefined}
            alt={user.email || ''}
            sx={{
              width: 28,
              height: 28,
              fontSize: 11,
              border: '2px solid white',
              ml: index === 0 ? 0 : -1,
              zIndex: visible.length - index,
            }}>
            {!user.photo_link && getInitials(user.email)}
          </Avatar>
        </Tooltip>
      ))}
      {overflow > 0 && (
        <Avatar
          sx={{
            width: 28,
            height: 28,
            fontSize: 11,
            border: '2px solid white',
            ml: -1,
            bgcolor: 'grey.400',
          }}>
          +{overflow}
        </Avatar>
      )}
    </Box>
  );
}

export default withTranslation()(AvatarGroupStacked);
